import { useMyContext } from "../context/MyContext"
import Popup from "./login/Popup";
import TermsModal from "./termsAndConditions/TermsModal";

const PopupWrapper = () => {
    const { open, setOpen, showTermsModal } = useMyContext()

    // Render both modals independently based on their own state
    return (
        <>
            {open && <Popup open={open} setOpen={setOpen} />}
            {showTermsModal && <TermsModal isOpen={showTermsModal} />}
        </>
    )
}

export default PopupWrapper